module.exports = __webpack_public_path__ + "assets/img/4b218fe9a2c75b795a7097d874249acb.png";